// extracted by mini-css-extract-plugin
module.exports = {"activeLabel":"quizEditorStyles_activeLabel__1dOai","inactiveLabel":"quizEditorStyles_inactiveLabel___pqbZ"};